export const validPlusSubscriptionIds = [
  5, 6, 7, 8, 9, 10, 12, 13, 77, 95, 11, 98, 102, 103, 104, 110, 113, 115, 123,
  126, 128, 142, 1158, 1510, 1394,
];

export const validPPSubscriptionIds = [90];
